import React from 'react';

import { Box, CircularProgress, Dialog, DialogContent, Typography } from '@mui/material';

import { Z_INDEX } from '@/constants/z-index';

type LoadingModalProps = {
  open: boolean;
  message?: string;
};

const dialogSx = { zIndex: Z_INDEX.loadingBackdrop };
const backdropSx = { backgroundColor: 'rgba(0,0,0,0.5)' };
const contentSx = { display: 'flex', alignItems: 'center', gap: 2 };
const messageSx = { fontWeight: 600 };
const subTextSx = { mt: 0.5 };

// Simple, reusable loading modal for long-running export operations
// - Uses MUI Dialog with a blocking backdrop
// - Prevents closing via ESC/backdrop to avoid interrupting in-flight requests
// - Accessible via role and aria-busy
const LoadingModal: React.FC<LoadingModalProps> = ({
  open,
  message = 'Processing your export…'
}) => {
  return (
    <Dialog
      aria-modal
      keepMounted
      aria-busy={open}
      open={open}
      sx={dialogSx}
      slotProps={{
        backdrop: { sx: backdropSx }
      }}
      onClose={() => {}}
    >
      <DialogContent sx={contentSx}>
        <CircularProgress
          aria-label='loading'
          size={24}
        />
        <Box>
          <Typography
            component='p'
            sx={messageSx}
          >
            {message}
          </Typography>
          <Typography
            color='text.secondary'
            component='p'
            sx={subTextSx}
          >
            This may take a few seconds. Please do not close this window.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingModal;
